// Controls section — only exception endpoints. Slice 2.
import { api } from "@/core/api/client";
import type { ControlException, UpdateExceptionRequest } from "@/core/api/types";

export async function listExceptions(reportId: string): Promise<ControlException[]> {
  const data = await api.get<{ exceptions: ControlException[] }>(`/reports/${reportId}/exceptions`);
  return data.exceptions;
}

export async function updateException(
  exceptionId: string,
  req: UpdateExceptionRequest
): Promise<ControlException> {
  const data = await api.patch<{ exception: ControlException }>(`/exceptions/${exceptionId}`, req);
  return data.exception;
}

export async function createException(
  reportId: string,
  req: {
    control_id: string;
    description: string; // the auditor's exception text
    page?: number | null;
    control_objective?: string | null;
    management_response?: string | null;
  }
): Promise<ControlException> {
  const data = await api.post<{ exception: ControlException }>(`/reports/${reportId}/exceptions`, req);
  return data.exception;
}

export async function deleteException(exceptionId: string): Promise<void> {
  await api.delete<{ deleted: boolean }>(`/exceptions/${exceptionId}`);
}
